import { render, staticRenderFns } from "./RefAziDownloads.vue?vue&type=template&id=665264c6&scoped=true"
import script from "./RefAziDownloads.vue?vue&type=script&lang=js"
export * from "./RefAziDownloads.vue?vue&type=script&lang=js"
import style0 from "./RefAziDownloads.vue?vue&type=style&index=0&id=665264c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665264c6",
  null
  
)

export default component.exports